/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Step/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Step({
  children,
  viewPath = "/DesignSystem/AppsLauncherProperties/Content/Steps/Step"
  
}) {
let stepDescriptionValueData = fromData.useDataValue({ viewPath,
context: 'step',
path: 'description',
})
let stepItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Step.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="step.description"
 text={stepDescriptionValueData}
 size="normal"
/>
<fromFlow.When is={!stepItemIsLastValueData}>
<div
  data-testid="Step.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-1-bokV': dtColorsNeutral300,'--ml-2-bokV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-bokV': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}